import React, { useState } from 'react';

import { EditorColumn } from 'leeloo-react/component/dataTable/column/EditorColumn';
import { SimpleColumn } from 'leeloo-react/component/dataTable/column/SimpleColumn';
import { DataTable } from 'leeloo-react/component/dataTable/DataTable';
import { Filter } from 'leeloo-react/component/filter/Filter';
import { InputField } from 'leeloo-react/component/form/field/InputField';
import { useDataSource } from 'leeloo-react/component/hook/useDataSource';

import { ResourceDataProviderEnum } from '../../../../enum/ResourceDataProviderEnum';
import { RouteEnum } from '../../../../enum/RouteEnum';
import { CustomFilterDataProviderType } from '../../../../model/dataProvider/CustomFilterDataProviderType';
import { ListColumn } from '../../../dataTable/column/ListColumn';
import { DataTableBulksActions } from '../../../dataTable/DataTableBulksActions';
import { DataTableHeaderActions } from '../../../dataTable/DataTableHeaderActions';
import { DataTableListActions } from '../../../dataTable/DataTableListActions';
import { SwitchField } from '../../../form/SwitchField';

export function ELearningDataTable() {
  const [filters, setFilters] = useState<CustomFilterDataProviderType>({});
  const dsELearnings = useDataSource({
    resource: ResourceDataProviderEnum.eLearning,
    params: {
      pagination: { page: 1, take: 50 },
      filter: { adminList: true },
    },
  });
  const exportNameFile = 'elearnings.csv';

  console.log(dsELearnings);

  return (
    <DataTable
      dataSource={dsELearnings}
      filter={(
        <Filter>
          <InputField name="search" label="Rechercher" onChangeValue={(v) => setFilters({ search: v })} />
        </Filter>
      )}
      actionHeader={(
        <DataTableHeaderActions
          addRoute={RouteEnum.ADMIN_E_LEARNING_ADD}
          addRouteValue="Créer une action de formation"
          importResource={ResourceDataProviderEnum.eLearningImport}
          exportResource={ResourceDataProviderEnum.eLearningExport}
          exportNameFile={exportNameFile}
          exportFilters={filters}
          dataSource={dsELearnings}
        />
      )}
      actionRow={(row) => [
        <DataTableListActions
          key={0}
          row={row}
          dataSource={dsELearnings}
          readRoute={RouteEnum.ADMIN_E_LEARNING_SHOW}
          deleteResource={ResourceDataProviderEnum.eLearning}
          duplicateResource={ResourceDataProviderEnum.eLearningDuplicate}
          editRoute={RouteEnum.ADMIN_E_LEARNING_EDIT}
        />,
      ]}
      onChangeCheckedRow={(rows: {id: number|string}[], cleanSelection) => (
        <DataTableBulksActions
          rows={rows}
          dataSource={dsELearnings}
          deleteResource={ResourceDataProviderEnum.eLearning}
          exportResource={ResourceDataProviderEnum.eLearningExport}
          exportNameFile={exportNameFile}
          duplicateResource={ResourceDataProviderEnum.eLearningDuplicate}
          cleanSelection={cleanSelection}
        />
      )}
    >
      <SimpleColumn field="intitule" title="Action de formation" sortable />
      <ListColumn field="themes" fieldColumns="theme.name" fieldKey="theme.id" title="Thème" />
      <SimpleColumn field="duree" title="Durée" sortable />
      <SimpleColumn field="nbApprenants" title="Apprenants en cours" />
      <EditorColumn
        field="actif"
        title="Status"
        resource={ResourceDataProviderEnum.eLearningUpdateStatus}
        columnElement={SimpleColumn}
        inputElement={<SwitchField />}
        center
        sortable
        forceEditable
      />
    </DataTable>
  );
}
